import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=50e329aa&scoped=true&"
import script from "./loader.vue?vue&type=script&lang=ts&"
export * from "./loader.vue?vue&type=script&lang=ts&"
import style0 from "./loader.vue?vue&type=style&index=0&id=50e329aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e329aa",
  null
  
)

export default component.exports